export type ComboStepConfig = {
    step: number
    type: string
    title: string
    shortTitle: string
    /** Id de lectura del registry flexible (para foto/layout correctos) */
    spreadId?: string
    /** Cantidad de cartas del paso (por defecto 10) */
    cardCount?: number
    /** Requiere numerología del consultante (fecha de nacimiento) */
    requiresPersonalityNumerology?: boolean
    /** Fija la modalidad de la tirada del amor (ej. '4' = Amor para Solteros) */
    fixedLoveTipo?: string
    loveTipoLabel?: string
    /** Tirada del Amor: el usuario elige modalidad en el wizard */
    isLoveMultimodal?: boolean
    /** Pedir datos del consultado en este paso */
    needsConsultado?: boolean
}

export type ComboPreambleMeta = {
    firstStepIntro: string
    finalStepClosing: string
}

export const COMBO_MIN_STEPS = 2
export const COMBO_MAX_STEPS = 5
